"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var changeElementTag_1 = require("./changeElementTag");
var contains_1 = require("./contains");
var createRange_1 = require("../selection/createRange");
var findClosestElementAncestor_1 = require("./findClosestElementAncestor");
var getBlockElementAtNode_1 = require("../blockElements/getBlockElementAtNode");
var getTagOfNode_1 = require("./getTagOfNode");
var isNodeEmpty_1 = require("./isNodeEmpty");
var isPositionAtBeginningOf_1 = require("../selection/isPositionAtBeginningOf");
var isVoidHtmlElement_1 = require("./isVoidHtmlElement");
var Position_1 = require("../selection/Position");
var queryElements_1 = require("./queryElements");
var splitTextNode_1 = require("./splitTextNode");
var toArray_1 = require("./toArray");
var unwrap_1 = require("./unwrap");
var VTable_1 = require("../table/VTable");
var wrap_1 = require("./wrap");
var splitParentNode_1 = require("./splitParentNode");
var adjustSteps = [handleHyperLink, handleStructuredNode, handleParagraph, handleVoidElement];
/**
 * Adjust the given position and return a better position (if any) or the given position
 * which will be the best one for inserting the given node.
 * @param root Root node of the scope
 * @param nodeToInsert The node about to be inserted
 * @param position The original position to insert the node
 */
function adjustNodeInsertPosition(root, nodeToInsert, position) {
    adjustSteps.forEach(function (handler) {
        position = handler(root, nodeToInsert, position);
    });
    return position;
}
exports.default = adjustNodeInsertPosition;
function handleHyperLink(root, nodeToInsert, position) {
    var blockElement = getBlockElementAtNode_1.default(root, position.node);
    if (blockElement) {
        // Find the first <A> tag within current block which covers current selection
        // If there are more than one nested, let's handle the first one only since that is not a common scenario.
        var anchor = queryElements_1.default(root, 'a[href]', null /*forEachCallback*/, 1 /* OnSelection */, createRange_1.default(position)).filter(function (a) { return blockElement.contains(a); })[0];
        // If this is about to insert node to an empty A tag, clear the A tag and reset position
        if (anchor && isNodeEmpty_1.default(anchor)) {
            position = new Position_1.default(anchor, -2 /* Before */);
            safeRemove(anchor);
            anchor = null;
        }
        // If this is about to insert nodes which contains A tag into another A tag, need to break current A tag
        // otherwise we will have nested A tags which is a wrong HTML structure
        if (anchor &&
            nodeToInsert.querySelector &&
            nodeToInsert.querySelector('a[href]')) {
            var normalizedPosition = position.normalize();
            var parentNode = normalizedPosition.node.parentNode;
            var nextNode = normalizedPosition.node.nodeType == 3 /* Text */
                ? splitTextNode_1.default(normalizedPosition.node, normalizedPosition.offset, false /*returnFirstPart*/)
                : normalizedPosition.isAtEnd
                    ? normalizedPosition.node.nextSibling
                    : normalizedPosition.node;
            var splitter = root.ownerDocument.createTextNode('');
            parentNode.insertBefore(splitter, nextNode);
            while (contains_1.default(anchor, splitter)) {
                splitter = splitParentNode_1.splitBalancedNodeRange(splitter);
            }
            position = new Position_1.default(splitter, -2 /* Before */);
            safeRemove(splitter);
        }
    }
    return position;
}
function handleStructuredNode(root, nodeToInsert, position) {
    var rootNodeToInsert = nodeToInsert;
    if (rootNodeToInsert.nodeType == 11 /* DocumentFragment */) {
        var rootNodes = toArray_1.default(rootNodeToInsert.childNodes).filter(function (n) { return getTagOfNode_1.default(n) != 'BR'; });
        rootNodeToInsert = rootNodes.length == 1 ? rootNodes[0] : null;
    }
    var tag = getTagOfNode_1.default(rootNodeToInsert);
    var hasBrNextToRoot = tag && getTagOfNode_1.default(rootNodeToInsert.nextSibling) == 'BR';
    var listItem = findClosestElementAncestor_1.default(position.node, root, 'LI');
    var listNode = listItem && findClosestElementAncestor_1.default(listItem, root, 'OL,UL');
    var tdNode = findClosestElementAncestor_1.default(position.node, root, 'TD,TH');
    var trNode = tdNode && findClosestElementAncestor_1.default(tdNode, root, 'TR');
    if (tag == 'LI') {
        tag = listNode ? getTagOfNode_1.default(listNode) : 'UL';
        rootNodeToInsert = wrap_1.default(rootNodeToInsert, tag);
    }
    if ((tag == 'OL' || tag == 'UL') && getTagOfNode_1.default(rootNodeToInsert.firstChild) == 'LI') {
        var shouldInsertListAsText = !rootNodeToInsert.firstChild.nextSibling && !hasBrNextToRoot;
        if (hasBrNextToRoot && rootNodeToInsert.parentNode) {
            safeRemove(rootNodeToInsert.nextSibling);
        }
        if (shouldInsertListAsText) {
            unwrap_1.default(rootNodeToInsert.firstChild);
            unwrap_1.default(rootNodeToInsert);
        }
        else if (getTagOfNode_1.default(listNode) == tag) {
            unwrap_1.default(rootNodeToInsert);
            position = new Position_1.default(listItem, isPositionAtBeginningOf_1.default(position, listItem)
                ? -2 /* Before */
                : -3 /* After */);
        }
    }
    else if (tag == 'TABLE' && trNode) {
        // When inserting a table into a table, if these tables have the same column count, and
        // current position is at beginning of a row, then merge these two tables
        var newTable = new VTable_1.default(rootNodeToInsert);
        var currentTable = new VTable_1.default(tdNode);
        if (currentTable.col == 0 &&
            tdNode == currentTable.getCell(currentTable.row, 0).td &&
            newTable.cells[0] &&
            newTable.cells[0].length == currentTable.cells[0].length &&
            isPositionAtBeginningOf_1.default(position, tdNode)) {
            if (getTagOfNode_1.default(rootNodeToInsert.firstChild) == 'TBODY' &&
                !rootNodeToInsert.firstChild.nextSibling) {
                unwrap_1.default(rootNodeToInsert.firstChild);
            }
            unwrap_1.default(rootNodeToInsert);
            position = new Position_1.default(trNode, -3 /* After */);
        }
    }
    return position;
}
function handleParagraph(root, nodeToInsert, position) {
    if (getTagOfNode_1.default(position.node) == 'P') {
        // Insert into a P tag may cause issues when the inserted content contains any block element.
        // Change P tag to DIV to make sure it works well
        var pos = position.normalize();
        var div = changeElementTag_1.default(position.node, 'div');
        if (pos.node != div) {
            position = pos;
        }
    }
    return position;
}
function handleVoidElement(root, nodeToInsert, position) {
    if (isVoidHtmlElement_1.default(position.node)) {
        position = new Position_1.default(position.node, position.isAtEnd ? -3 /* After */ : -2 /* Before */);
    }
    return position;
}
function safeRemove(node) {
    if (node && node.parentNode) {
        node.parentNode.removeChild(node);
    }
}
//# sourceMappingURL=adjustNodeInsertPosition.js.map